// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_parent__N9wGk {
}
.style_slider__jPkJV {
  width: 100%;
}
.style_unSliderCard__-34n5 {
  width: 25%;
}
.style_preBtn__XTChw {
  position: absolute;
  top: -5%;
  right: 5%;
}

.style_nextBtn__isDtS {
  position: absolute;
  top: -5%;
  right: 3%;
}

/* Responsive adjustments */
@media screen and (max-width: 1020px) {
  .style_preBtn__XTChw {
    /* top: -10%; */
    right: 8%;
  }
  .style_nextBtn__isDtS {
    /* top: -10%; */
    right: 4%;
  }
}

@media screen and (max-width: 480px) {
  .style_preBtn__XTChw {
    /* top: -15%; */
    right: 10%;
  }
  .style_nextBtn__isDtS {
    /* top: -15%; */
    right: 6%;
  }
}

@media only screen and (max-width: 1024px) {
  .style_unSliderCard__-34n5 {
    width: 50%;
  }
}
@media only screen and (max-width: 558px) {
  .style_unSliderCard__-34n5 {
    width: 100%;
  }
}

@media only screen and (max-width: 576px) {
  .style_preBtn__XTChw {
    /* top: -15%; */
    right: 15%;
  }
  .style_nextBtn__isDtS {
    /* top: -15%; */
    right: 6%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Common/Css/style.module.css"],"names":[],"mappings":"AAAA;AACA;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;IACf,SAAS;EACX;EACA;IACE,eAAe;IACf,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,SAAS;EACX;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;IACf,SAAS;EACX;AACF","sourcesContent":[".parent {\r\n}\r\n.slider {\r\n  width: 100%;\r\n}\r\n.unSliderCard {\r\n  width: 25%;\r\n}\r\n.preBtn {\r\n  position: absolute;\r\n  top: -5%;\r\n  right: 5%;\r\n}\r\n\r\n.nextBtn {\r\n  position: absolute;\r\n  top: -5%;\r\n  right: 3%;\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media screen and (max-width: 1020px) {\r\n  .preBtn {\r\n    /* top: -10%; */\r\n    right: 8%;\r\n  }\r\n  .nextBtn {\r\n    /* top: -10%; */\r\n    right: 4%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n  .preBtn {\r\n    /* top: -15%; */\r\n    right: 10%;\r\n  }\r\n  .nextBtn {\r\n    /* top: -15%; */\r\n    right: 6%;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 1024px) {\r\n  .unSliderCard {\r\n    width: 50%;\r\n  }\r\n}\r\n@media only screen and (max-width: 558px) {\r\n  .unSliderCard {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 576px) {\r\n  .preBtn {\r\n    /* top: -15%; */\r\n    right: 15%;\r\n  }\r\n  .nextBtn {\r\n    /* top: -15%; */\r\n    right: 6%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"parent": `style_parent__N9wGk`,
	"slider": `style_slider__jPkJV`,
	"unSliderCard": `style_unSliderCard__-34n5`,
	"preBtn": `style_preBtn__XTChw`,
	"nextBtn": `style_nextBtn__isDtS`
};
export default ___CSS_LOADER_EXPORT___;
